import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/parts/off-the-shelf-part-search')({
    // Only redirects: `/parts/search` checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    // Nothing links here any more, but old bookmarks still land here.
    // The table keeps its filters, sorting, search text and page in the query string, so all of it goes along.
    beforeLoad: () => {
        throw redirect({ to: '/parts/search', search: true });
    },
});
